<template>
  <div id="app">
    <AppHeader v-if="showSiteChrome" />
    <router-view />
    <AppFooter v-if="showSiteChrome" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
  computed: {
    showSiteChrome() {
      return !(this.$route && this.$route.meta && this.$route.meta.guest)
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'sysscre', 'SourceHanSerifCN Regular', Arial, sans-serif;
  color: #333;
  background-color: #f5f5f5;
}

a {
  text-decoration: none;
  color: inherit;
}

ul, ol {
  list-style: none;
}

img {
  max-width: 100%;
  vertical-align: middle;
}

.container {
  width: 1380px;
  margin: 0 auto;
}

@media (max-width: 1400px) {
  .container {
    width: 1200px;
  }
}

@media (max-width: 1200px) {
  .container {
    width: 1000px;
  }
}

@media (max-width: 1000px) {
  .container {
    width: 900px;
  }
}

@media (max-width: 900px) {
  .container {
    width: 73%;
  }
}

.clearfix::after {
  content: '';
  display: table;
  clear: both;
}
</style>
